// extracted by mini-css-extract-plugin
module.exports = {"multiselect":"BprForm_multiselect_ORCR0","quillEditorWrapper":"BprForm_quillEditorWrapper_26Ffq","spinAround":"BprForm_spinAround_1kJbo"};